import Accordion from "../../resources/js/modules/accordion";

const itemsAccordion = new Accordion();
itemsAccordion.init();


